import { inject } from 'mobx-react'
import React from 'react'
import { GENERAL_STORE } from 'store'
import { VideoPlayerProps } from './VideoPlayer.types'

const VideoPlayerComponent = (props: VideoPlayerProps) => {
  const {
    src,
    className,
    style,
    [GENERAL_STORE]: {
      setLoadingOn,
      setLoadingOff
    }
  } = props

  return (
    <video
      className={className}
      style={{ width: '100%', height: '100%', objectFit: 'contain', ...style }}
      controls
      onLoadStart={() => setLoadingOff()}
      onLoadedData={() => setLoadingOff()}
    >
      <source src={src as string} />
      {/* {console.log('video', video)} */}
      {/* <source src='mov_bbb.ogg' type='video/ogg' /> */}
      Your browser does not support HTML5 video.
    </video>
  )
}
const VideoPlayer = inject(GENERAL_STORE)(VideoPlayerComponent)
export { VideoPlayer }
